import {TextField, TextFieldProps} from '@mui/material';

export const PublicTextField = (props: TextFieldProps) => {
    return <TextField {...props} margin="normal" fullWidth />;
};
